import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { get } from "../../services/api";

const ProductList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const REACT_APP_LIVE_DOMAIN_URL = process.env.REACT_APP_LIVE_DOMAIN_URL;
  const [selectedCategory, setSelectedCategory] = useState("All");
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const [summaryData, setSummaryData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const navigate = useNavigate();
const baseUrl = process.env.REACT_APP_LIVE_DOMAIN_URL
  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await get(`SalesOffers/summary`);
       

        console.log("data", response);
        setSummaryData(response);
      } catch (error) {
        console.error("Error fetching summary data:", error);
      }
    };

    fetchSummary();
  }, []);
   useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await get(`ItemCategory/bysupercategory/1`);
      
        console.log("Categorydata", response);
        setCategoryData(response);
      } catch (error) {
        console.error("Error fetching summary data:", error);
      }
    };

    fetchSummary();
  }, []);


  const categories = ["All", "Uniform", "Electronics", "Stationery"];

  const handleOfferExplore = (id) => {
    navigate(`/cart/${id}`);
  };

 const handleExplore = (id) => {
  navigate('/uniform', { state: { id } });
};

  const category = [
    {
      'salesOfferID' : 10,
      'itemName' : 'Uniform'
    },
    {
      'salesOfferID' : 15,
       'itemName' : 'IT Equipment'
    },
    
    {
      'salesOfferID' : 16,
       'itemName' : 'Stationary'
    }
  ];  
  return (
 <div className="container mt-4">
  
  <h5  className="mt-5 mb-3 px-3"
  style={{
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#1C355E',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderRadius: '4px'
  }}
>
    Choose a category to buy
  </h5>
  <div className="row">
    {categoryData.map((product) => {
  

  return (
    <div key={product.categoryID} className="col-md-4 mb-4">
      <div className="card shadow-sm position-relative h-100">
        <img
          src={`${baseUrl}MarketPlace${product.categoryImage}`}
          className="card-img-top mt-4"
          alt={product.categoryName}
          style={{ height: "200px", objectFit: "cover" }}
        />

        <div className="card-body d-flex flex-column justify-content-between">
          <h6
            className="card-title fw-bold"
            style={{ fontSize: "16px", paddingLeft: "0rem" }}
          >
            {product.categoryName}
          </h6>

          <p
            className="card-text"
            style={{ fontSize: "14px", paddingLeft: "0rem" }}
          >
            {product.description}
          </p>

          <div className="text-center mt-3">
            <button
              className="btn btn-primary btn-sm"
              style={{
                backgroundColor: "#1C355E",
                borderColor: "#0d6efd",
                color: "white",
              }}
              onClick={() => handleExplore(product.categoryID)}
            >
              Explore
            </button>
          </div>
        </div>
      </div>
    </div>
  );
})}

  </div>

  {/* 🎯 Sales Category Section */}
  <h5  className="mt-5 mb-3 px-3"
  style={{
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#1C355E',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderRadius: '4px'
  }}
>
    Special Sales Offer
  </h5>
  <div className="row">
    {summaryData.map((product) => (
      <div key={product.salesOfferID} className="col-md-4 mb-4">
        <div className="card shadow-sm position-relative h-100">
          <div
            style={{
              position: "absolute",
              top: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "red",
              color: "white",
              fontWeight: "bold",
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "13px",
              zIndex: 1,
            }}
          >
            {product.discount > 0
              ? `SAVE ${product.discount}%`
              : `New Arrival`}
          </div>

          <img
            src={`${REACT_APP_LIVE_DOMAIN_URL}ExternalImages/MarketPlace${product.bannerImage}`}
            className="card-img-top mt-4"
            alt={product.itemName}
            style={{ height: "200px", objectFit: "cover" }}
          />

          <div className="card-body d-flex flex-column justify-content-between">
            <h6
              className="card-title fw-bold"
              style={{ fontSize: "16px", paddingLeft: "0rem" }}
            >
              {product.itemName}
            </h6>
            <p
              className="card-text"
              style={{ fontSize: "14px", paddingLeft: "0rem" }}
            >
              {product.summaryDescription}
            </p>
            <div className="text-center mt-3">
              <button
                className="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#1C355E",
                  borderColor: "#0d6efd",
                  color: "white",
                }}
                onClick={() => handleOfferExplore(product.salesOfferID)}
              >
                Explore Offers
              </button>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  );
};

export default ProductList;
